// API endpoints configuration
export const API_CONFIG = {
  // Sitemap XML remote URL
  SITEMAP_URL: 'https://api.escortfun.net/bot/xml.php',
  // Country code detection endpoint
  COUNTRY_CODE_URL: import.meta.env.VITE_FG,
  // Authentication configuration
  AUTH: {
    MODEL: 'efusers',
    BASE_URL: 'https://api.escortfun.net/api/v2/index.php', // Add your actual API base URL here
  },
  // Data models configuration
  MODELS: {
    ESCORTS: 'escorts',
    GALLERY: 'gallery',
  },
  // Countries configuration
  COUNTRIES: {
    ITALIA: {
      code: 'it',
      model: 'escorts_italia',
    },
    SVIZZERA: {
      code: 'ch', 
      model: 'escorts_svizzera',
    },
  },
};
